import React, { useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import FilterBoxCompanyPage from './FilterBoxCompanyPage'
import countryData from '../data/countryData.json'
import {
  ClearSmallIcon,
  ExpandFilterIcon,
  FilterMobileIcon,
  RefreshMobileIcon,
} from './Icons'
import { INIT_FILTER } from './PortfolioTableMobile'
import { INIT_FILTER_STATE } from '../ultils/dataUtil'
import { markSelectedFilterData } from '../ultils/filterData'

const useStyles = makeStyles({
  toolbarFilterBar: {
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 'unset',
    paddingBottom: 10,
    borderBottom: '1px solid #DFE4EB',
  },
  title: {
    flex: '1 1 100%',
    fontSize: 20,
    lineHeight: '24.5px',
    color: '#181818',
    marginRight: 34,
  },
  search: {
    display: 'flex',
    alignItems: 'center',
  },
  filter: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      color: '#474747',
      fontWeight: 600,
      fontSize: 14,
    },
  },
  searchName: {
    minWidth: 300,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#F4F5F7',
    borderRadius: 3,
    padding: 12,
    '& svg': {
      width: 16,
      height: 16,
      color: '#474747',
    },
    '& input': {
      border: 'none',
      background: 'transparent',
      paddingLeft: 8,
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 400,
      outline: 'none',
      width: 'calc(100% - 20px)',

      '&::placeholder': {
        fontSize: 14,
        lineHeight: '22px',
        fontWeight: 400,
        color: '#757575',
      },
    },
  },
  reset: {
    color: '#1B3963 !important',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 20,
    cursor: 'pointer',
  },
  resetText: {
    lineHeight: '22px',
    fontWeight: 400,
  },
  ReplayIcon: {
    width: 18,
    height: 18,
    marginRight: 2,
  },
  dropdownStatus: {
    marginBottom: 12,
  },
  dropdownType: {
    marginBottom: 12,
  },
  dropdownLocation: {
    marginBottom: 12,
  },
  filterBy: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#474747',
  },
  mFilterBoxHead: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  mFilterBoxSearchBox: {
    height: 40,
    width: 'calc(100% - 50px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    background: '#F4F5F7',
    borderRadius: 3,
    boxSizing: 'border-box',
    paddingLeft: 12,
    paddingRight: 12,
  },
  mFilterBoxSearchIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mFilterBoxSearchInput: {
    width: '100%',
    height: '100%',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    paddingLeft: 8,
    paddingRight: 8,
    '&:active': {
      border: 'none',
      outline: 'none',
    },
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  mFilterBoxSearchClear: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mFilterBoxExpandIcon: {
    width: 40,
    height: 40,
    border: '1px solid #DFE4EB',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mFilterBoxOptionModal: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: 'rgba(0,0,0,0.4)',
    zIndex: 100,
  },
  mFilterBoxOptionContent: {
    width: '80%',
    height: '100%',
    background: 'white',
  },
  mFilterBoxOptionModalHead: {
    height: 80,
    borderBottom: '1px solid #DFE4EB',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20,
    width: '100%',
  },
  mFilterBoxOptionModalHeadTitle: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#181818',
  },
  mFilterBoxOptionModalHeadFunction: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  mFilterBoxOptionModalHeadResetIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mFilterBoxOptionModalHeadResetTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#1B3963',
    marginLeft: 6,
  },
  mFilterBoxOptionModalFooter: {
    height: 30,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },
  ExpandFilterIcon: {
    transformOrigin: 'center',
    transform: 'rotate(180deg)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mFilterBoxOptionModalBody: {
    height: 'calc(100% - 110px)',
    width: '100%',
    boxSizing: 'border-box',
    padding: '24px 20px',
  },
})
interface FilterProps {
  tickers: any
  selectedFilter: typeof INIT_FILTER
  setSelectedFilter: (params: typeof INIT_FILTER) => void
  onResetAll: () => void
}
const FilterPortfolioTableMobile = ({
  tickers,
  selectedFilter,
  setSelectedFilter,
  onResetAll,
}: FilterProps) => {
  const classes = useStyles()
  const [reset, setReset] = useState(false)
  const [initFilterTitle, setInitFilterTitle] = useState(INIT_FILTER_STATE)
  const [searchByName, setSearchByName] = useState<any>('')

  const getDynamicFilterData = (staticList: any, dynamicList: any) => {
    return markSelectedFilterData(staticList, dynamicList)
  }

  const uniqueSector: any = [
    ...new Set(tickers?.map((t: any) => t.factset_sector_desc)),
  ]
  const sectorData = [...new Set(uniqueSector)].map((value: any, id: any) => ({
    id,
    value,
    isChecked: false,
    type: 'sector',
  }))

  const uniqueIndustry: any = [...new Set(tickers?.map((t: any) => t.industry))]
  const industryData = [...new Set(uniqueIndustry)].map(
    (value: any, id: any) => ({
      id,
      value,
      isChecked: false,
      type: 'industry',
    }),
  )

  const uniqueCountry: any = [
    ...new Set(tickers?.map((t: any) => t.iso_country)),
  ]
  const countryDataNews = countryData
    .filter(item => uniqueCountry.includes(item.id))
    .map((value, id) => ({
      id: value.id,
      value: value.value,
    }))

  const uniqueRegion: any = [...new Set(tickers?.map((t: any) => t.region))]
  const regionData = [...new Set(uniqueRegion)].map((value: any, id: any) => ({
    id,
    value,
    isChecked: false,
  }))

  const internalSectorData = useMemo(() => {
    return getDynamicFilterData(sectorData, selectedFilter.sector)
  }, [selectedFilter.sector, tickers])

  const internalIndustryData = useMemo(() => {
    return getDynamicFilterData(industryData, selectedFilter.industry)
  }, [selectedFilter.industry, tickers])

  const internalRegionData = useMemo(() => {
    return getDynamicFilterData(regionData, selectedFilter.region)
  }, [selectedFilter.region, tickers])

  const internalCountryData = useMemo(() => {
    return getDynamicFilterData(countryDataNews, selectedFilter.country)
  }, [selectedFilter.country, tickers])

  const setFilterValue = (val: any, type: any) => {
    if (type === 'sector') {
      const sectorList = val
        .filter((item: any) => item.type === 'sector')
        .map((item: any) => item.value)
      const industryList = val
        .filter((item: any) => item.type === 'industry')
        .map((item: any) => item.value)
      setSelectedFilter({
        ...selectedFilter,
        sector: sectorList,
        industry: industryList,
      })
    } else if (type === 'country') {
      const countryList = val
        .filter((item: any) => isNaN(item.id))
        .map((item: any) => item.id)
      const regionList = val
        .filter((item: any) => !isNaN(item.id))
        .map((item: any) => item.value)
      setSelectedFilter({
        ...selectedFilter,
        region: regionList,
        country: countryList,
      })
    }
    setReset(false)
  }

  const handleReset = () => {
    setReset(true)
    setInitFilterTitle(INIT_FILTER_STATE)
    setSelectedFilter({
      sector: [],
      industry: [],
      region: [],
      country: [],
      searchByWord: '',
    })
    onResetAll()
  }

  const handleChangeSearchByName = (e: any) => {
    setSearchByName(e.target.value)
    setSelectedFilter({
      ...selectedFilter,
      searchByWord: e.target.value,
    })
  }

  const [toggleFilterMobile, setToggleFilterMobile] = useState(false)

  const onExpandMore = () => {
    setToggleFilterMobile(true)
  }

  const onHandleCollapse = () => {
    setToggleFilterMobile(false)
  }

  const onHandClickOutSideFilterModal = (event: any) => {
    if (event.target !== event.currentTarget) return
    setToggleFilterMobile(false)
  }

  const onClearInputFilter = () => {
    setSearchByName('')
    onResetAll()
  }

  return (
    <div className={classes.toolbarFilterBar}>
      <div className={classes.mFilterBoxHead}>
        <div className={classes.mFilterBoxSearchBox}>
          <div className={classes.mFilterBoxSearchIcon}>
            <SearchIcon />
          </div>
          <input
            className={classes.mFilterBoxSearchInput}
            value={searchByName}
            onChange={handleChangeSearchByName}
            placeholder="Search by name"
          />
          {searchByName !== '' && (
            <div
              onClick={onClearInputFilter}
              className={classes.mFilterBoxSearchClear}
            >
              <ClearSmallIcon />
            </div>
          )}
        </div>
        <div onClick={onExpandMore} className={classes.mFilterBoxExpandIcon}>
          <FilterMobileIcon />
        </div>

        <div
          className={classes.mFilterBoxOptionModal}
          onClick={onHandClickOutSideFilterModal}
          style={{
            transition: 'all 0.3s',
            transform: `translateX(${toggleFilterMobile ? 0 : -100}%)`,
          }}
        >
          <div className={classes.mFilterBoxOptionContent}>
            <div className={classes.mFilterBoxOptionModalHead}>
              <div className={classes.mFilterBoxOptionModalHeadTitle}>
                Filter
              </div>
              <div
                onClick={handleReset}
                className={classes.mFilterBoxOptionModalHeadFunction}
              >
                <div className={classes.mFilterBoxOptionModalHeadResetIcon}>
                  <RefreshMobileIcon />
                </div>
                <div className={classes.mFilterBoxOptionModalHeadResetTitle}>
                  Reset
                </div>
              </div>
            </div>

            <div className={classes.mFilterBoxOptionModalBody}>
              <div className={classes.dropdownType}>
                <FilterBoxCompanyPage
                  placeholder={initFilterTitle.sector}
                  data={[
                    {
                      title: 'Sector',
                      list: internalSectorData,
                      heightScrollList: 160,
                    },
                    {
                      title: 'Industry',
                      list: internalIndustryData,
                      heightScrollList: 160,
                    },
                  ]}
                  setFilterValue={(val: any) => setFilterValue(val, 'sector')}
                  isSearch={false}
                  isRadio={false}
                  isReset={reset}
                  customStyle={{ width: '100%' }}
                  itemInfo={[
                    sectorData.map((itemOut: any) => {
                      return {
                        id: itemOut.id,
                        value: tickers.filter(
                          (item: any) =>
                            item.factset_sector_desc === itemOut.value,
                        ).length,
                        isChecked: reset || itemOut.isChecked,
                        type: 'sector',
                      }
                    }),
                    industryData.map((itemOut: any) => {
                      return {
                        id: itemOut.id,
                        value: tickers.filter(
                          (item: any) => item.industry === itemOut.value,
                        )?.length,
                        isChecked: reset || itemOut.isChecked,
                        type: 'industry',
                      }
                    }),
                  ]}
                />
              </div>
              <div className={classes.dropdownLocation}>
                <FilterBoxCompanyPage
                  placeholder={initFilterTitle.country}
                  data={[
                    {
                      title: 'Region',
                      list: internalRegionData,
                      heightScrollList: 160,
                    },
                    {
                      title: 'Country',
                      list: internalCountryData,
                      heightScrollList: 160,
                    },
                  ]}
                  setFilterValue={(val: any) => {
                    setFilterValue(val, 'country')
                  }}
                  isSearch
                  isRadio={false}
                  isReset={reset}
                  customStyle={{ width: '100%' }}
                  itemInfo={[
                    regionData.map((itemOut: any) => {
                      return {
                        id: itemOut.id,
                        value: tickers.filter(
                          (item: any) => item.region === itemOut.value,
                        ).length,
                        isChecked: reset || itemOut.isChecked,
                      }
                    }),
                    countryDataNews.map((itemOut: any) => {
                      return {
                        id: itemOut.id,
                        value: tickers.filter(
                          (item: any) => item.iso_country === itemOut.id,
                        ).length,
                        isChecked: reset || itemOut.isChecked,
                      }
                    }),
                  ]}
                />
              </div>
            </div>

            <div className={classes.mFilterBoxOptionModalFooter}>
              <div
                onClick={onHandleCollapse}
                className={classes.ExpandFilterIcon}
              >
                <ExpandFilterIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FilterPortfolioTableMobile
